import { Trans } from 'react-i18next';
import { Flex } from 'ui';
import { Text } from 'ui/typography';

type P = {
  whoShouldEnroll: string;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramEnroll = ({ whoShouldEnroll }: P) => (
  <Flex>
    <Flex className="card-content" vertical>
      <Text className="card-content__title">
        <Trans>Who should enroll</Trans>
      </Text>
      <Text className="program-enroll__description">{whoShouldEnroll}</Text>
    </Flex>
  </Flex>
);

export default ProgramEnroll;
